import { LogoutState } from '@pages/logout/store/state/logout.state';
import { OpenIdConnectLogoutState } from '@pages/logout/store/state/open-id-connect-logout.state';

export const logoutState = [LogoutState, OpenIdConnectLogoutState];
